import { Injectable, inject } from '@angular/core';
import moment from 'moment';
import { Observable } from 'rxjs';

import { api } from '../../models/api-url.model';
import { SurveyRatingSince, SurveyYearNPS } from '../../models/survey.model';
import { ApiService } from '../../core/services/api';

@Injectable({
  providedIn: 'root',
})
export class SurveyService {
  private readonly apiService = inject(ApiService);

  getYearNPS(year: string | number): Observable<SurveyYearNPS> {
    return this.apiService.get(`${api.surveyURL}/year-nps/${year}`);
  }

  getRatingSince(since: moment.MomentInput): Observable<SurveyRatingSince> {
    const date = moment(since);
    return this.apiService.get(
      `${api.surveyURL}/rating-since/${date.format('YYYY-MM-DD')}`,
    );
  }
}
